// 5.37.0 Quad / Year — pure helpers (tested in calendarGrid.test.js). Days are Chicago WALL dates 'YYYY-MM-DD';
// months are 'YYYY-MM'. Never the PC's own zone (see calendarTime.js).
import { addDays, todayWall, wallDate } from './calendarTime';
import { shortTime } from './calendarPanes';

export const ym = (y, m0) => `${y}-${String(m0 + 1).padStart(2, '0')}`;
export function addYM(s, n) {
  const [y, m] = s.split('-').map(Number);
  const t = y * 12 + (m - 1) + n;
  return ym(Math.floor(t / 12), ((t % 12) + 12) % 12);
}
export const thisYM = () => todayWall().slice(0, 7);
export const thisYear = () => Number(todayWall().slice(0, 4));

const fmtMonth = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long', year: 'numeric' });
const fmtMonthOnly = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long' });
const fmtShortMonth = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', year: 'numeric' });
const fmtDay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' });
const D = (d) => new Date(`${d}T00:00:00Z`);
export const monthTitle = (s) => fmtMonth.format(D(`${s}-01`));
export const monthName = (s) => fmtMonthOnly.format(D(`${s}-01`));
export const quadTitle = (s) => `${fmtShortMonth.format(D(`${s}-01`))} – ${fmtShortMonth.format(D(`${addYM(s, 3)}-01`))}`;
export const dayLabel = (d) => fmtDay.format(D(d));

// The weeks (Sunday first) that show month `s`: 4–6 rows, or always 6 with fixed6 (Year keeps months aligned).
export function monthWeeks(s, fixed6 = false) {
  const first = `${s}-01`;
  const next = `${addYM(s, 1)}-01`;
  let d = addDays(first, -D(first).getUTCDay());
  const weeks = [];
  while (fixed6 ? weeks.length < 6 : d < next) {
    const w = [];
    for (let i = 0; i < 7; i += 1) { w.push(d); d = addDays(d, 1); }
    weeks.push(w);
  }
  return weeks;
}

// Days an event (occurrence) covers. All-day ends are exclusive; a timed event ending exactly at 00:00 does not
// cover that day; a zero-length event counts on its own day. Capped at 400 days.
export function eventDays(e) {
  const s = wallDate(e.start);
  let last;
  if (e.allDay) {
    last = e.end ? addDays(wallDate(e.end), -1) : s;
  } else {
    const end = e.end || e.start;
    last = wallDate(end);
    if (end > e.start && end.slice(11, 19) === '00:00:00') last = addDays(last, -1);
  }
  if (last < s) last = s;
  const out = [];
  for (let d = s; d <= last && out.length < 400; d = addDays(d, 1)) out.push(d);
  return out;
}

// {day: [events]} for days in [from, to), each day: all-day first, then by start time, then title.
export function eventsByDay(events, from, to) {
  const out = {};
  events.forEach((e) => eventDays(e).forEach((d) => {
    if (d >= from && d < to) (out[d] = out[d] || []).push(e);
  }));
  Object.values(out).forEach((list) => list.sort((a, b) => (
    (a.allDay === b.allDay ? 0 : a.allDay ? -1 : 1) || (a.start < b.start ? -1 : a.start > b.start ? 1 : 0)
    || (a.title || '').localeCompare(b.title || ''))));
  return out;
}

// "9a Title" (all-day: just the title); hover adds the location.
export function entryLabel(e) {
  if (e.allDay || (e.start || '').length <= 10) return e.title;
  return `${shortTime(Number(e.start.slice(11, 13)), Number(e.start.slice(14, 16)))} ${e.title}`;
}
export const entryHover = (e) => [entryLabel(e), e.location].filter(Boolean).join(' · ');
export const dayHover = (d, list) => [dayLabel(d), ...list.map(entryLabel)].join('\n');
